/* @flow */
import * as React from 'react';

import type { StoreType } from '../../data/Stores';
import LogoGrid from './LogoGrid';
import type { LogoType } from './LogoGrid';

const storeToLogo = (storeId, store): LogoType => {
  return {
    path: `/services/${storeId}-delivery`,
    image: store.logoSmall,
    image2x: store.logoSmall2x,
    imageWidth: store.logoSmallWidth,
    imageAlt: store.name,
  };
};

export default function StoreGrid({ stores }: { stores: { [id: string]: StoreType } }) {
  let logos = Object.keys(stores).map(id => {
    return storeToLogo(id, stores[id]);
  });

  return <LogoGrid logos={logos} />;
}



// WEBPACK FOOTER //
// ./src/ui/components/StoreGrid.js